const symbols = '1234567890QWERTYUIOPASDFGHJKLZXCVBNM';
export function nanoid(size: number) {
  return Array(size)
    .fill(0)
    .map(_ => symbols[Math.floor(Math.random() * symbols.length)])
    .join('');
}

/** poor man's shuffle... */
export function shuffle<T extends unknown[]>(arr: T) {
  return [...arr].sort(() => (Math.random() > 0.5 ? 1 : -1));
}
